import React, { useMemo } from 'react';
import MenuItemsModal from './MenuItem/MenuItemsModal';
import OrderMethodModal from './order-method/OrderMethodModal';
import LoginModal from './LoginModal';
import InfoModal from './InfoModal';
import FreeProductsModal from './FreeProductsModal';
import useAppState from '../hooks/global/useAppState';
import OtpVerificationModal from './OtpVerificationModal';
import RestaurantClosedModal from './restaurant-closed/RestaurantClosedModal';
import OrderBasketModal from './order-basket';
import OfferModal from './offer/OfferModal';
import EligibleOffersModal from './eligible-offers/EligibleOffersModal';
import FreeItemsModal from './free-items/FreeItemsModal';
import useMobileApp from '../hooks/mobile-app/useMobileApp';
import MobileAppSignupBonusModal from './mobile-app-signup-bonus/MobileAppSignupBonusModal';

export default function GlobalModalsStack() {
  const {
    orderMethodModalProps,
    otpVerificationModalProps,
    freeProductsModalProps,
    menuItemModalProps,
    restaurantClosedModalProps,
    orderBasketModalProps,
    offerModalProps,
    eligibleOffersModalProps,
    freeItemsModalProps,
    mobileAppSignupBonusProps,
  } = useAppState();
  const { isMobileApp } = useMobileApp();

  const { openModal: orderMethodModalOpen } = orderMethodModalProps;
  const { openModal: otpVerificationModalOpen } = otpVerificationModalProps;
  const { openModal: menuItemModalOpen } = menuItemModalProps;
  const { openModal: freeProductsModalOpen } = freeProductsModalProps;
  const { openModal: restaurantClosedModalOpen } = restaurantClosedModalProps;
  const { openModal: orderBasketModalOpen } = orderBasketModalProps;

  const renderOrderMethodModal = useMemo(
    () => orderMethodModalOpen && !isMobileApp && <OrderMethodModal />,
    [orderMethodModalOpen, isMobileApp],
  );

  const renderOtpVerificationModal = useMemo(
    () => otpVerificationModalOpen && <OtpVerificationModal />,
    [otpVerificationModalOpen],
  );

  const renderMenuItemsModal = useMemo(() => menuItemModalOpen && <MenuItemsModal />, [menuItemModalOpen]);

  const renderFreeProductsModal = useMemo(
    () => freeProductsModalOpen && <FreeProductsModal />,
    [freeProductsModalOpen],
  );

  const renderInfoModal = useMemo(() => <InfoModal />, []);

  const renderRestaurantClosedModal = useMemo(
    () => restaurantClosedModalOpen && <RestaurantClosedModal />,
    [restaurantClosedModalOpen],
  );

  const renderOrderBasketModal = useMemo(
    () => <OrderBasketModal open={orderBasketModalOpen} />,
    [orderBasketModalOpen],
  );

  const renderOfferModal = useMemo(
    () => offerModalProps.openModal && <OfferModal {...offerModalProps} />,
    [offerModalProps],
  );

  const renderEligibleOffersModal = useMemo(
    () => eligibleOffersModalProps.openModal && <EligibleOffersModal />,
    [eligibleOffersModalProps],
  );

  const renderFreeItemsModal = useMemo(
    () => freeItemsModalProps.openModal && <FreeItemsModal {...freeItemsModalProps} />,
    [freeItemsModalProps],
  );

  const renderMobileAppSignupBonusModal = useMemo(
    () => mobileAppSignupBonusProps.openModal && <MobileAppSignupBonusModal {...mobileAppSignupBonusProps} />,
    [mobileAppSignupBonusProps],
  );

  return (
    <>
      <LoginModal />
      {renderOrderMethodModal}
      {renderOtpVerificationModal}
      {renderMenuItemsModal}
      {renderFreeProductsModal}
      {renderInfoModal}
      {renderRestaurantClosedModal}
      {renderOrderBasketModal}
      {renderOfferModal}
      {renderEligibleOffersModal}
      {renderFreeItemsModal}
      {renderMobileAppSignupBonusModal}
    </>
  );
}
